import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  Row,
  Col,
  Button,
  FormGroup,
  FormControl,
  ControlLabel,
  Label,
  Modal,
  Checkbox,
} from "react-bootstrap";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import Alert from "../../../components/alert/Alert";
import { createBrowserHistory } from "history";
import "../../../style/subAdmin/SubAdmin.scss";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import auth from "../../../services/auth";
import { aclUtil } from "../../util";
import { get_merchant_list } from "../../../redux/actions/merchantActions";
import {
  get_site_details,
  updateAccountSettings,
} from "../../../redux/actions/siteActions";

import { getPayoutList } from "../../../redux/actions/payoutActions";
const getBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
    reader.readAsDataURL(file);
  });
};
const history = createBrowserHistory();

class AccountSetting extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      menuKey: "ACCOUNT_SETTINGS",
      siteID: "",
      msgType: "",
      alertMessage: "",
      pending_offers: "disable",
      prior_hours_pending_offers: "",
      search_location: "",
      search_deals: "",
      search_loc_on_dektop: "",
      search_deals_on_dektop: "",
      show_menu_on_desktop: "",
      show_menu_on_mobile: "",
      show_gift_card: "",
      charity: "disable",
      featured_offer: 1,
      payoutList: [],
      merchantList: [],
      password_protect: "inactive",
      font_families: "",
      combine_products: "enable",
      offercity: "0",
      broadcasting: "",
      emailqu: "",
      reservedcart: "",
      reservedtime: 2,
      reservedqa: "",
      upcominglink:"",
      subscribe:"0",
      sub_label_en:"",
      sub_button_en:"",
      sub_label_fr:"",
      sub_button_fr:"",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.loadSiteDetails = this.loadSiteDetails.bind(this);
  }

  loadSiteDetails = () => {
    let user = auth.getUserInfo() ? auth.getUserInfo() : null;
    this.props.get_site_details(user.siteID);
  };

  componentWillMount() {
    this.loadSiteDetails();
    this.props.getPayoutList();
    this.props.get_merchant_list({ page: 0 });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.merchantList !== nextProps.merchantList) {
      if (nextProps.merchantList) {
        this.setState({ merchantList: nextProps.merchantList });
      }
    }

    if (this.props.payoutList !== nextProps.payoutList) {
      if (nextProps.payoutList) {
        this.setState({ payoutList: nextProps.payoutList.data.data });
      }
    }

    if (this.props.accountUpdated !== nextProps.accountUpdated) {
      if (!isEmpty(nextProps.accountUpdated)) {
        this.setState({
          alertMessage:
            nextProps.accountUpdated.message &&
            nextProps.accountUpdated.message,
          msgType: "success",
        });
        this.loadSiteDetails();
        window.scrollTo(0, 0);
      }
    }

    if (this.props.siteDetails !== nextProps.siteDetails) {
      if (nextProps.siteDetails) {
        let site = nextProps.siteDetails;
        this.setState({
          id: site.id,
          siteID: site.siteID,
          pending_offers: site.pending_offers,
          prior_hours_pending_offers: site.prior_hours_pending_offers,
          featured_offer: site.featured_offer,
          search_location: site.search_location,
          search_deals: site.search_deals,
          search_loc_on_dektop: site.search_loc_on_dektop,
          search_deals_on_dektop: site.search_deals_on_dektop,
          show_menu_on_desktop: site.show_menu_on_desktop,
          show_menu_on_mobile: site.show_menu_on_mobile,
          show_gift_card: site.show_gift_card,
          charity: site.charity,
          xml_import: site.xml_import,
          xml_merchant_id: site.xml_merchant_id,
          xml_payment_term: site.xml_payment_term,
          xml_url: site.xml_url,
          password_protect: site.password_protect,
          font_families: site.font_families,
          combine_products: site.combine_products,
          offercity: site.offerCity,
          broadcasting: site.broadcasting,
          emailqu: site.emailqu,
          reservedcart: site.reservedcart,
          reservedtime: site.appversion,
          reservedqa: site.reservedqa,
          upcominglink:site.upcominglink,
          subscribe:site.subscribe,
          sub_label_en:site.sub_label_en,
          sub_button_en:site.sub_button_en,
          sub_label_fr:site.sub_label_fr,
          sub_button_fr:site.sub_button_fr,
        });
      }
    }
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  handleSubmit(e) {
    e.preventDefault();
    const updateData = {
      id: this.state.id,
      siteID: this.state.siteID,
      pending_offers: this.state.pending_offers,
      prior_hours_pending_offers: this.state.prior_hours_pending_offers,
      featured_offer: this.state.featured_offer,
      search_location: this.state.search_location,
      search_deals: this.state.search_deals,
      search_loc_on_dektop: this.state.search_loc_on_dektop,
      search_deals_on_dektop: this.state.search_deals_on_dektop,
      show_menu_on_desktop: this.state.show_menu_on_desktop,
      show_menu_on_mobile: this.state.show_menu_on_mobile,
      show_gift_card: this.state.show_gift_card,
      charity: this.state.charity,
      xml_import: this.state.xml_import,
      xml_merchant_id: this.state.xml_merchant_id,
      xml_payment_term: this.state.xml_payment_term,
      xml_url: this.state.xml_url,
      broadcasting: this.state.broadcasting,
      emailqu: this.state.emailqu,
      reservedcart: this.state.reservedcart,
      appversion: this.state.reservedtime,
      password_protect: this.state.password_protect,
      font_families: this.state.font_families,
      combine_products: this.state.combine_products,
      offercity: this.state.offercity,
      reservedqa: this.state.reservedqa,
      upcominglink:this.state.upcominglink,
      subscribe:this.state.subscribe,
      sub_button_en:this.state.sub_button_en,
      sub_label_en:this.state.sub_label_en,
      sub_button_fr:this.state.sub_button_fr,
      sub_label_fr:this.state.sub_label_fr,
    };
    this.props.updateAccountSettings(updateData);
  }

  render() {
    return (
      <div className="col-lg-12 add-sub-admin">
        <div className="row">
          {(this.state.alertMessage !== "" || this.props.error) && (
            <div className="col-lg-12">
              <Notification type={this.state.msgType}>
                <span>
                  <strong>{this.state.msgType}:</strong>{" "}
                  {this.state.alertMessage || this.props.error}
                </span>
              </Notification>
            </div>
          )}
        </div>
        <form onSubmit={this.handleSubmit}>
          <div className="panel">
            <header className="panel-heading">Offer Setting</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsFeaturedStatus">
                    <ControlLabel>Featured Offer</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="featured_offer"
                      value={this.state.featured_offer}
                      onChange={this.handleChange}
                    >
                      <option value="1">Enable</option>
                      <option value="0">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsPendingOfferStatus">
                    <ControlLabel>Pending Offer Status</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="pending_offers"
                      value={this.state.pending_offers}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsPendingHours">
                    <ControlLabel>
                      How many hours prior to going live should the offer be
                      visible?
                    </ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.prior_hours_pending_offers}
                      placeholder="Enter Hours"
                      onChange={this.handleChange}
                      name="prior_hours_pending_offers"
                      disabled={
                        this.state.pending_offers == "disable" ? true : false
                      }
                    />
                    <span style={{ fontSize: "12px", color: "#666" }}>
                      (If left blank then offers will show from the time they
                      are in the Pending section til live.)
                    </span>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">XML Setting</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formXMLStatus">
                    <ControlLabel>XML Import</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="xml_import"
                      value={this.state.xml_import}
                      onChange={this.handleChange}
                    >
                      <option value="1">Enable</option>
                      <option value="0">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formMerchantStatus">
                    <ControlLabel>Default Merchant</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="xml_merchant_id"
                      onChange={this.handleChange}
                      value={this.state.xml_merchant_id}
                      disabled={this.state.xml_import == 0 ? true : false}
                      style={{ borderColor: this.state.merchantIDError }}
                    >
                      <option value="">Choose Merchant Name</option>
                      {this.state.merchantList.map((el, key) => {
                        return (
                          <option key={key} value={el.merchantID}>
                            {el.merchantName}
                          </option>
                        );
                      })}
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formPaymentStatus">
                    <ControlLabel>Default Payment Terms </ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="xml_payment_term"
                      onChange={this.handleChange}
                      value={this.state.xml_payment_term}
                      disabled={this.state.xml_import == 0 ? true : false}
                      style={{ borderColor: this.state.payment_term_idError }}
                    >
                      <option value="">Choose Option</option>
                      {this.state.payoutList !== [] &&
                        this.state.payoutList.map((data, index) => (
                          <option key={index} value={data.termID}>
                            {data.termName}
                          </option>
                        ))}
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsPendingHours">
                    <ControlLabel>XML URL</ControlLabel>
                    <FormControl
                      type="text"
                      value={this.state.xml_url}
                      placeholder="Enter Hours"
                      disabled={this.state.xml_import == 0 ? true : false}
                      onChange={this.handleChange}
                      name="xml_url"
                    />
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Subscribe form Text Setting</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formSubscribeStatus">
                    <ControlLabel>Dynamic Subscribe Form</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="subscribe"
                      value={this.state.subscribe}
                      onChange={this.handleChange}
                    >
                      <option value="1">Enable</option>
                      <option value="0">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formMerchantStatus">
                    <ControlLabel>Subscribe Label English</ControlLabel>
                    <FormControl
                      
                      name="sub_label_en"
                      onChange={this.handleChange}
                      value={this.state.sub_label_en}
                      disabled={this.state.subscribe == 0 ? true : false}
                      style={{ borderColor: this.state.merchantIDError }}
                    >
                     
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formMerchantStatus">
                    <ControlLabel>Subscribe Label French</ControlLabel>
                    <FormControl
                      
                      name="sub_label_fr"
                      onChange={this.handleChange}
                      value={this.state.sub_label_fr}
                      disabled={this.state.subscribe == 0 ? true : false}
                      style={{ borderColor: this.state.merchantIDError }}
                    >
                     
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formMerchantStatus">
                    <ControlLabel>Subscribe Button Text English</ControlLabel>
                    <FormControl
                      
                      name="sub_button_en"
                      onChange={this.handleChange}
                      value={this.state.sub_button_en}
                      disabled={this.state.subscribe == 0 ? true : false}
                      style={{ borderColor: this.state.merchantIDError }}
                    >
                     
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formMerchantStatus">
                    <ControlLabel>Subscribe Button Text French</ControlLabel>
                    <FormControl
                      
                      name="sub_button_fr"
                      onChange={this.handleChange}
                      value={this.state.sub_button_fr}
                      disabled={this.state.subscribe == 0 ? true : false}
                      style={{ borderColor: this.state.merchantIDError }}
                    >
                     
                    </FormControl>
                  </FormGroup>
                </Col>
              
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Other Setting</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsPasswordProtect">
                    <ControlLabel>Site Password</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="password_protect"
                      value={this.state.password_protect}
                      onChange={this.handleChange}
                    >
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Font Options</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsFontFamilies">
                    <ControlLabel>Font Families</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="font_families"
                      value={this.state.font_families}
                      onChange={this.handleChange}
                    >
                      <option value="">Choose Font Families</option>
                      <option value="Alegreya, serif">Alegreya</option>
                      <option value="Alegreya Sans, sans-serif">
                        Alegreya Sans
                      </option>
                      <option value="Andika, sans-serif">Andika</option>
                      <option value="Andika New Basic, sans-serif">
                        Andika New Basic
                      </option>
                      <option value="Anonymous Pro, monospace">
                        Anonymous Pro
                      </option>
                      <option value="Archivo Narrow, sans-serif">
                        Archivo Narrow
                      </option>
                      <option value="BioRhyme, serif">BioRhyme</option>
                      <option value="Cabin, sans-serif">Cabin</option>
                      <option value="Cardo, serif">Cardo</option>
                      <option value="Chivo, sans-serif">Chivo</option>
                      <option value="Concert One, cursive">Concert One</option>
                      <option value="Cormorant, serif">Cormorant</option>
                      <option value="Crimson Text, serif">Crimson Text</option>
                      <option value="Eczar, serif">Eczar</option>
                      <option value="Fira Sans, sans-serif">Fira Sans</option>
                      <option value="Grandstander, cursive">
                        Grandstander
                      </option>
                      <option value="Harmattan, sans-serif">Harmattan</option>
                      <option value="IBM Plex Sans, sans-serif">
                        IBM Plex Sans
                      </option>
                      <option value="Imbue, serif">Imbue</option>
                      <option value="Inconsolata, monospace">
                        Inconsolata
                      </option>
                      <option value="Inknut Antiqua, serif">
                        Inknut Antiqua
                      </option>
                      <option value="Inter, sans-serif">Inter</option>
                      <option value="Karla, sans-serif">Karla</option>
                      <option value="Lateef, cursive">Lateef</option>
                      <option value="Lato, sans-serif">Lato</option>
                      <option value="Libre Baskerville, serif">
                        Libre Baskerville
                      </option>
                      <option value="Libre Franklin, sans-serif">
                        Libre Franklin
                      </option>
                      <option value="Lora, serif">Lora</option>
                      <option value="Merriweather, serif">Merriweather</option>
                      <option value="Montserrat, sans-serif">Montserrat</option>
                      <option value="Neuton, serif">Neuton</option>
                      <option value="Noto Sans, sans-serif">Noto Sans</option>
                      <option value="Nunito Sans, sans-serif">
                        Nunito Sans
                      </option>
                      <option value="Open Sans, sans-serif">Open Sans</option>
                      <option value="Oswald, sans-serif">Oswald</option>
                      <option value="Padauk, sans-serif">Padauk</option>
                      <option value="Playfair Display, serif">
                        Playfair Display
                      </option>
                      <option value="Poppins, sans-serif">Poppins</option>
                      <option value="Potta One, cursive">Potta One</option>
                      <option value="Prompt, sans-serif">Prompt</option>
                      <option value="Proza Libre, sans-serif">
                        Proza Libre
                      </option>
                      <option value="PT Sans, sans-serif">PT Sans</option>
                      <option value="PT Serif, serif">PT Serif</option>
                      <option value="Raleway, sans-serif">Raleway</option>
                      <option value="Red Rose, cursive">Red Rose</option>
                      <option value="Reggae One, cursive">Reggae One</option>
                      <option value="Roboto, sans-serif">Roboto</option>
                      <option value="Roboto Slab, serif">Roboto Slab</option>
                      <option value="Rokkitt, serif">Rokkitt</option>
                      <option value="Rubik, sans-serif">Rubik</option>
                      <option value="Scheherazade, serif">Scheherazade</option>
                      <option value="Source Sans Pro, sans-serif">
                        Source Sans Pro
                      </option>
                      <option value="Source Serif Pro, serif">
                        Source Serif Pro
                      </option>
                      <option value="Space Grotesk, sans-serif">
                        Space Grotesk
                      </option>
                      <option value="Space Mono, monospace">Space Mono</option>
                      <option value="Spectral, serif">Spectral</option>
                      <option value="Syne Mono, monospace">Syne Mono</option>
                      <option value="Texturina, serif">Texturina</option>
                      <option value="Work Sans, sans-serif">Work Sans</option>
                      <option value="Yusei Magic, sans-serif">
                        Yusei Magic
                      </option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsFontFamilies">
                    <ControlLabel
                      style={{ fontFamily: this.state.font_families }}
                    >
                      The font-family Property {this.state.font_families}
                    </ControlLabel>
                    <div style={{ fontFamily: this.state.font_families }}>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book. It has survived not only five
                      centuries, but also the leap into electronic typesetting,
                      remaining essentially unchanged. It was popularised in the
                      1960s with the release of Letraset sheets containing Lorem
                      Ipsum passages, and more recently with desktop publishing
                      software like Aldus PageMaker including versions of Lorem
                      Ipsum.
                    </div>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">Product Reports</header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsCombineProducts">
                    <ControlLabel>Combine Products And Offers</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="combine_products"
                      value={this.state.combine_products}
                      onChange={this.handleChange}
                      disabled={
                        this.state.combine_products == "enable" ? true : false
                      }
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
            </div>
          </div>

          <div className="panel">
            <header className="panel-heading">
              Turn on/off search and location option
            </header>
            <div className="panel-body">
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsOfferStatus">
                    <ControlLabel>Search Option on Mobile</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="search_deals"
                      value={this.state.search_deals}
                      onChange={this.handleChange}
                    >
                      <option value="on">ON</option>
                      <option value="off">OFF</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formLocationOption">
                    <ControlLabel>Location Option on Mobile</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="search_location"
                      value={this.state.search_location}
                      onChange={this.handleChange}
                    >
                      <option value="on">ON</option>
                      <option value="off">OFF</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsOfferStatus">
                    <ControlLabel>Search Option on Desktop</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="search_deals_on_dektop"
                      value={this.state.search_deals_on_dektop}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formLocationOption">
                    <ControlLabel>Location Option on Desktop</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="search_loc_on_dektop"
                      value={this.state.search_loc_on_dektop}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsOfferStatus">
                    <ControlLabel>Charity</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="charity"
                      value={this.state.charity}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsOffercity">
                    <ControlLabel>Show offer live city</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="offercity"
                      value={this.state.offercity}
                      onChange={this.handleChange}
                    >
                      <option value="1">Enable</option>
                      <option value="0">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsMenuMobStatus">
                    <ControlLabel>Show Menu on Mobile</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="show_menu_on_mobile"
                      value={this.state.show_menu_on_mobile}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsMenuStatus">
                    <ControlLabel>Show Menu on Desktop</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="show_menu_on_desktop"
                      value={this.state.show_menu_on_desktop}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsGiftCardStatus">
                    <ControlLabel>
                      Show Gift Card Offer Types On Landing Pages
                    </ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="show_gift_card"
                      value={this.state.show_gift_card}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>

                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsGiftCardStatus">
                    <ControlLabel>Live Broadcasting</ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="broadcasting"
                      value={this.state.broadcasting}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsGiftCardStatus">
                    <ControlLabel>Email Queue Process </ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="emailqu"
                      value={this.state.emailqu}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
                <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsGiftCardStatus">
                    <ControlLabel>Quantity Reserved </ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="reservedqa"
                      value={this.state.reservedqa}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>


     <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsGiftCardStatus">
                    <ControlLabel>Enable Upcoming Offer Link </ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="upcominglink"
                      value={this.state.upcominglink}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>




                 <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsGiftCardStatus">
                    <ControlLabel>Voucher Never Expired </ControlLabel>
                    <FormControl
                      componentClass="select"
                      name="reservedcart"
                      value={this.state.reservedcart}
                      onChange={this.handleChange}
                    >
                      <option value="enable">Enable</option>
                      <option value="disable">Disable</option>
                    </FormControl>
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                {/*  <Col md={6} xs={12}>
                  <FormGroup controlId="formControlsGiftCardStatus">
                    <ControlLabel>Reserved Time </ControlLabel>
                      <FormControl
                      type="number"
                      value={this.state.reservedtime}
                      placeholder="Enter Minute"
                      onChange={this.handleChange}
                      name="reservedtime"
                     
                    />
                  </FormGroup>
                </Col>*/}
              </Row>

              <Row>
                <Col md={12} xs={12}>
                  <Button bsStyle="info" type="submit">
                    Submit
                  </Button>
                  <Button
                    bsStyle="default"
                    type="button"
                    onClick={() =>
                      this.context.router.history.push(`/editSite`)
                    }
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

AccountSetting.propTypes = {
  get_site_details: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  siteDetails: state.siteReducer.siteDetails,
  accountUpdated: state.siteReducer.accountUpdated,
  payoutList: state.payoutReducer.payoutList,
  merchantList: state.merchantReducer.merchantList,
});

export default compose(
  withRouter,
  connect(mapStateToProps, {
    get_site_details,
    get_merchant_list,
    getPayoutList,
    updateAccountSettings,
  })
)(AccountSetting);



// WEBPACK FOOTER //
// ./src/app/views/admin/setting/AccountSetting.js